import type { FlowDefinition } from '@tutlo/contracts'
import { FLOW_END } from './engine.ts'

/**
 * Flow `test`: 3–4 pytania z jednym branchingiem. Służy testom engine'u, placeholderowi UI
 * i jako slug dla leadów testowych (`is_test`). Copy docelowe przyjdzie z Google Doca Marty (M1).
 * Walidacja schematem `flowDefinition` dzieje się w teście (`flows.test.ts`), nie przy imporcie:
 * `core` nie może ciągnąć Zoda do bundle'a SPA (budżet 100 KB).
 */
export const testFlow = {
  slug: 'test',
  title: 'Kwalifikator testowy',
  start: 'goal',
  questions: [
    {
      id: 'goal',
      title: 'Po co Ci angielski?',
      options: [
        { value: 'work', label: 'Do pracy', emoji: '💼' },
        { value: 'travel', label: 'Do podróży', emoji: '✈️' },
        { value: 'exam', label: 'Do egzaminu', emoji: '🎓' },
        { value: 'self', label: 'Dla siebie', emoji: '🎯' },
      ],
      next: 'level',
    },
    {
      id: 'level',
      title: 'Jak oceniasz swój poziom?',
      options: [
        { value: 'zero', label: 'Zaczynam od zera', emoji: '🌱', next: 'fear' },
        { value: 'basic', label: 'Rozumiem, ale nie mówię', emoji: '📗' },
        { value: 'mid', label: 'Dogadam się', emoji: '📘' },
        { value: 'high', label: 'Mówię swobodnie', emoji: '📕' },
      ],
      next: 'usage',
    },
    {
      id: 'usage',
      title: 'Jak często używasz angielskiego?',
      options: [
        { value: 'daily', label: 'Codziennie', emoji: '📅' },
        { value: 'weekly', label: 'Kilka razy w tygodniu', emoji: '🗓️' },
        { value: 'rarely', label: 'Rzadko', emoji: '🌤️' },
      ],
      next: 'fear',
    },
    {
      id: 'fear',
      title: 'Czy stresujesz się, gdy masz mówić po angielsku?',
      options: [
        { value: 'yes', label: 'Tak, bardzo', emoji: '😰' },
        { value: 'bit', label: 'Trochę', emoji: '😬' },
        { value: 'no', label: 'Raczej nie', emoji: '🙂' },
      ],
      next: FLOW_END,
    },
  ],
} satisfies FlowDefinition
